import { useMutation } from 'react-query';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import useForm from '../../lib/hooks/useForm';
import { signIn } from './data';
import i18n from '../../app/i18n';

const validationSchema = yup.object({
  email: yup.string().required(i18n.t('signIn:emailRequired')),
  password: yup.string().required(i18n.t('signIn:passwordRequired')),
});

const useSignIn = () => {
  const { mutate } = useMutation(signIn);
  const { t } = useTranslation('signIn');

  const onSubmit = (values, { setFieldError, setFieldValue }) => {
    mutate(values, {
      onSuccess: ({ data }) => {
        window.location.href = data.path;
      },
      onError: ({ response }) => {
        if (response.data.not_found) {
          setFieldValue('errorField', t('invalidCredentials'), false);
          setFieldError('email', ' ');
          setFieldError('password', ' ');
        }
      },
    });
  };

  const initialValues = {
    email: '',
    password: '',
    errorField: '',
    rememberMe: false,
  };

  return useForm({
    initialValues,
    onSubmit,
    validationSchema,
  });
};

export default useSignIn;
